import Popup from 'components/popup';
import Slider from 'components/slider';
import vrIcon from 'components/vr-icon';

// Подключаем слайдер с примерами планировок
const flatsWrap = document.querySelector('.j-slider-flats');

if (flatsWrap) {
    const sliderFlats = new Slider();

    sliderFlats.init({
        slider       : flatsWrap,
        dots         : false,
        thumbnails   : false,
        arrow        : true,
        counter      : true,
        arrowPosition: 'caption',
        modify       : 'flat_slide'
    });
}

// Подключаем слайдер в инфраструктуре
const infraSliderWrap = document.querySelector('.j-slider-infra');

if (infraSliderWrap) {
    const sliderInfra = new Slider();

    sliderInfra.init({
        slider       : infraSliderWrap,
        dots         : false,
        thumbnails   : false,
        arrow        : true,
        counter      : true,
        arrowPosition: 'caption',
        modify       : 'infra_slide',
        noSwipe      : true,
        slideVisible : 2,
        responsive   : {
            0   : 1.1,
            670 : 2,
            960 : 2,
            1280: 2
        }
    });
}

// Запуск кнопки vr с баннером
const vrIconSelector = Array.from(document.querySelectorAll('.j-vr-icon'));

if (vrIconSelector.length) {
    vrIconSelector.forEach((item) => {
        vrIcon(item);
    });
}

// Подключение попапов с панорамой
const popupPlanoplanLinks = Array.from(document.querySelectorAll('.j-popup-planoplan'));

if (popupPlanoplanLinks.length) {
    const popupOptions = {
        openButtons         : popupPlanoplanLinks,
        closeButtonAriaLabel: 'Закрыть 3D тур',
        template            : 'marginless'
    };

    const popupPlanoplan = new Popup(popupOptions);

    popupPlanoplan.init();
}
